import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { UsersComponent } from '../users.component';
@Component({
  selector: 'app-add-users',
  templateUrl: './add-users.component.html',
  styleUrls: ['./add-users.component.scss']
})
export class AddUsersComponent implements OnInit {

  addUserForm: FormGroup;
  missingFieldMsg = false;
  @ViewChild('closeBtn') closeBtn: ElementRef;
  password: any;

  constructor(private appComp: AppComponent, private formBuilder: FormBuilder, private authService: AuthenticationService, private users: UsersComponent) { }

  ngOnInit(): void {
    this.addUserForm = this.formBuilder.group({
      UserFullName: ["", Validators.required],
      // UserName: ["", Validators.required],
      UserEmail: ["", Validators.required],
      UserPword: ["", Validators.required],
      UserPhoneNo: [""],
      role: ["", Validators.required],
    });
  }

  addUser(){
    this.appComp.loading = true;
    this.missingFieldMsg = false;
    if (this.addUserForm.invalid) {
      this.missingFieldMsg = true;
      this.appComp.loading = false;
      return;
    }
    let formObj = this.addUserForm.getRawValue();
    formObj.UserName = formObj.UserEmail;
    console.log(formObj);
    this.authService.addUser(formObj).then(res=>{
      console.log(res);
      this.closeBtn.nativeElement.click();
      this.users.getUsers();
      this.appComp.loading = false;
    }, err =>{
      console.log(err);
      this.appComp.loading = false;
    })
  }

  checkPassword(){
    this.password = this.addUserForm.controls['UserPword'].value;
  }

}
